// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"8e5709bf","939":"6b0f8718"}[chunkId] + ".chunk.js";
};